<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ grocer.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <GrocerTabLinks />
                    <CRow class="pl-3 pb-3" />
                    <CRow class="pl-3 pb-3">
                        <table class="table">
                            <thead>
                                <th>Название</th>
                                <th>Тип</th>
                                <th>Активный</th>
                            </thead>
                            <tr v-for="promotion in promotions" :key="promotion.title">
                                <td>
                                    <CLink :to="`/grocers/${grocer.id}/promotions/${promotion.id}`">{{ promotion.title }}</CLink>
                                </td>
                                <td>{{ promotionTypeTitle(promotion.type) }}</td>
                                <td>
                                    <CBadge :color="getBadge(promotion.enabled)">
                                        &nbsp;{{ promotion.enabled ? "Да" : "Нет" }}&nbsp;
                                    </CBadge>
                                </td>
                            </tr>
                        </table>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="create">Создать</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import GrocerTabLinks from '@/components/grocers/GrocerTabLinks';
    import { promotionTypeTitle } from '../../utils/promotion-views';

    export default {

        name: 'GrocerPromotions',
        components: {
            GrocerTabLinks,
        },

        data() {
            return {
                grocer: {},
                promotions: [],
            };
        },

        computed: {},

        mounted() {
            const id = this.$route.params.id;
            Vue.axios
                .get(`/grocers/${id}`)
                .then(resp => {
                    this.grocer = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios
                .get('/promotions/grocers/' + id)
                .then(resp => {
                    this.promotions = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            create() {
                this.$router.push(
                    '/grocers/' + this.grocer.id + '/promotions/create'
                );
            },

            getBadge(status) {
                return status ? 'success' : 'secondary';
            },

            promotionTypeTitle(type) {
                return promotionTypeTitle(type);
            },
        },
    };
</script>
<style scoped>
</style>
